import { captureFrontendError } from 'utils/captureFrontendError'
import { ionicStore } from '../../ionicStorage'
import type { TResponseCacheEntry } from './_types'

/**
 * Never rejects: a failed read is reported and treated as a cache miss, so the request still goes out.
 */
export const getResponseCacheEntry = async <TResponse>(
  key: string,
): Promise<TResponseCacheEntry<TResponse> | null> => {
  try {
    return (await ionicStore.get(key)) ?? null
  } catch (error) {
    captureFrontendError(error, { tags: { storageOperation: 'getResponseCacheEntry' } })

    return null
  }
}
